import Layout from "../components/Layout/Layout";
import Dashboard from "../components/dashboard/Dashboard";

const DashboardPage = () => {
  return (
    <Layout>
      <div>
        <Dashboard />
      </div>
    </Layout>
  );
};

export default DashboardPage;
